<template>
  <div class="lego-paging-table">
    <lego-table
      ref="table"
      v-model="selectedList"
      v-bind="$attrs"
      :noPage="noPage"
      :heightTable="heightTable"
      :resizeColumn="resizeColumn"
      @change="emitTableChange"
    >
      <template #title-action v-if="$slots['title-action']">
        <slot name="title-action" />
      </template>
      <template #customRow="{ attr, rowAttr }" v-if="$slots['customRow']">
        <slot name="customRow" :attr="attr" :rowAttr="rowAttr" />
      </template>
      <template #counter-instead v-if="$slots['counter-instead']">
        <slot name="counter-instead" />
      </template>
      <template #action v-if="$slots['action']">
        <slot name="action" />
      </template>
      <template #extra-action v-if="$slots['extra-action']">
        <slot name="extra-action" />
      </template>
      <template #extra-action-row v-if="$slots['extra-action-row']">
        <slot name="extra-action-row" />
      </template>
      <template #colgroup v-if="$slots['colgroup']">
        <slot name="colgroup" />
      </template>
      <template #header v-if="$slots['header']">
        <slot name="header" />
      </template>
      <template #expand="{ item }" v-if="$slots['expand']">
        <slot name="expand" :item="item" />
      </template>
      <template #items="{ item, index, attr }" v-if="$slots['items']">
        <slot name="items" :item="item" :index="index" :attr="attr" />
      </template>

      <template #no-data>
        <slot name="no-data"></slot>
      </template>
    </lego-table>
    <slot name="pagination"></slot>
    <lego-pagination-v2
      v-if="!$slots['pagination']"
      :pagination="$attrs.pagination"
      @move="changeCurrentPage"
    />
  </div>
</template>

<script>
export default {
  name: 'lego-paging-table',
  emits: ['page-move', 'change'],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    resizeColumn: {
      type: Boolean,
      default: true
    },
    noPage: {
      type: Boolean,
      default: false
    },
    heightTable: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.selectedList = val;
      }
    }
  },
  data: () => ({
    selectedList: []
  }),
  mounted() {
    this.selectedList = this.value;
  },
  methods: {
    changeCurrentPage(page) {
      this.$emit('page-move', page);
      this.$refs.table.changePages();
    },
    emitTableChange() {
      return this.$emit('change');
    }
  }
};
</script>
